import { cn } from '@/lib/utils'

/** The 8 graded levels — [backend enum value, short label, bg, fg], warm→cool. */
const GRADES: [value: string, label: string, bg: string, fg: string][] = [
  ['compliant', 'compliant', '#3269AF', '#fff'],
  ['partially_effective', 'partial', '#22417A', '#fff'],
  ['degraded', 'degraded', '#6C8CC8', '#08111e'],
  ['unverified', 'unverif.', '#FFB09D', '#08111e'],
  ['temporary_override', 'override', '#FF9274', '#08111e'],
  ['impaired', 'impaired', '#FF663C', '#08111e'],
  ['unknown', 'unknown', '#7C8AA0', '#fff'],
  ['absent', 'absent', '#F93804', '#fff'],
]

/** Signature 8-level graded-response control. `value`/`onChange` use the backend enum. */
export function GradedResponse({
  value,
  onChange,
}: {
  value?: string
  onChange?: (value: string) => void
}) {
  return (
    <div className="flex overflow-hidden rounded-md border border-input">
      {GRADES.map(([val, label, bg, fg]) => (
        <button
          key={val}
          onClick={() => onChange?.(val)}
          style={{ background: bg, color: fg }}
          className={cn(
            'flex-1 border-r border-black/15 px-1 py-2.5 text-center font-display text-[10px] font-semibold last:border-r-0',
            val === value && 'outline outline-2 -outline-offset-2 outline-foreground',
          )}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
